/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import styles from './ToTop.module.css';

const topArrowIcon = require('./imgs/arrow-icon.svg');

const ToTop = () => (
  <div className={styles.toTopWrapper}>
    <div
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth"})} // eslint-disable-line
      className={styles.toTopContainer}
    >
      <img alt="to-top" src={topArrowIcon} />
      <p>Top</p>
    </div>
  </div>
);

export default ToTop;
